import React from 'react';
import ReactDOM from 'react-dom/client';
import './output.css';
import store from './app/store';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { RouterProvider } from "react-router-dom";
import { router } from './router';
import ReactGA from "react-ga4";

// Initialize React Ga with your tracking ID


ReactGA.initialize('G-WS63J3G3PM');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <RouterProvider router={router} />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
